module.exports = __webpack_public_path__ + "static/media/img-card (8).961d1457.jpg";